import React from 'react';
import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import bodyAreaIcon from '../../assets/icons/categories/bodyArea.svg';
import model3DIcon from '../../assets/icons/categories/3DModelCategory.svg';
import chronicConditionsIcon from '../../assets/icons/categories/chronicConditions.svg';
import generalAnatomyAnimal from '../../assets/icons/categories/generalAnatomyAnimal.svg';
import generalPrinciplesAnimal from '../../assets/icons/categories/generalPrinciplesAnimal.svg';
import neurologyIcon from '../../assets/icons/categories/neurology.svg';
import mensHealthIcon from '../../assets/icons/categories/mensHealth.svg';
import womensHealthIcon from '../../assets/icons/categories/womensHealth.svg';
import behaviourIcon from '../../assets/icons/categories/behaviour.svg';
import emergencyIcon from '../../assets/icons/categories/emergency.svg';
import exoticAnimalsIcon from '../../assets/icons/categories/exoticAnimals.svg';
import farmIcon from '../../assets/icons/categories/farm.svg';
import musculoskeletalIcon from '../../assets/icons/categories/musculoskeletal.svg';
import medicalConditionsIcon from '../../assets/icons/categories/medicalConditions.svg';
import preventativeIcon from '../../assets/icons/categories/preventative.svg';
import parasitesIcon from '../../assets/icons/categories/parasites.svg';
import reproductionIcon from '../../assets/icons/categories/reproduction.svg';
import surgeryIcon from '../../assets/icons/categories/surgery.svg';
import animalIcon from '../../assets/icons/categories/animal.svg';
import denistryIcon from '../../assets/icons/categories/denistry.svg';
import dermatologyIcon from '../../assets/icons/categories/dermatology.svg';
import diagramIcon from '../../assets/icons/categories/diagrams.svg';
import orthopaedicIcon from '../../assets/icons/categories/orthopaedic.svg';
import ophthalmologyIcon from '../../assets/icons/categories/ophthalmology.svg';
import internalMedicineIcon from '../../assets/icons/categories/internalMedicine.svg';
import pulmonaryAndCardioIcon from '../../assets/icons/categories/pulmonaryAndCardio.svg';
import paediatricsIcon from '../../assets/icons/categories/paediatrics.svg';
import rheumatologyIcon from '../../assets/icons/categories/rheumatology.svg';
import seriousPathologiesIcon from '../../assets/icons/categories/seriousPathologies.svg';
import studentLearningIcon from '../../assets/icons/categories/studentLearning.svg';
import infectiousDiseaseIcon from '../../assets/icons/categories/infectiousDisease.svg';
import nutritionIcon from '../../assets/icons/categories/nutrition.svg';
import rehabilitationIcon from '../../assets/icons/categories/rehabilitation.svg';
import oncologyIcon from '../../assets/icons/categories/oncology.svg';
import cardiologyIcon from '../../assets/icons/categories/cardiology.svg';
import gastroenterologyIcon from '../../assets/icons/categories/gastroenterology.svg';
import hepatologyIcon from '../../assets/icons/categories/hepatology.svg';
import nephrologyUrinaryIcon from '../../assets/icons/categories/nephrologyUrinary.svg';

import birdIcon from '../../assets/icons/categories/bird.svg';
import canineIcon from '../../assets/icons/categories/canine.svg';
import chickenIcon from '../../assets/icons/categories/chicken.svg';
import felineIcon from '../../assets/icons/categories/feline.svg';
import fishIcon from '../../assets/icons/categories/fish.svg';
import tortoiseIcon from '../../assets/icons/categories/tortoise.svg';
import reptilesIcon from '../../assets/icons/categories/lizard.svg';
import snakeIcon from '../../assets/icons/categories/snake.svg';

import equineIcon from '../../assets/icons/categories/equine.svg';
import guineaPigIcon from '../../assets/icons/categories/guineaPig.svg';
import hamsterIcon from '../../assets/icons/categories/hamster.svg';
import rabbitIcon from '../../assets/icons/categories/rabbit.svg';
import smallAnimalsIcon from '../../assets/icons/categories/smallAnimals.svg';
import smallMammalsIcon from '../../assets/icons/categories/smallMammals.svg';

import largeAnimalsIcon from '../../assets/icons/categories/largeAnimals.svg';
import { useNavigate } from 'react-router-dom';

const categoryIconMap = {
    '3D Models': model3DIcon,
    Anatomy: generalAnatomyAnimal,
    Animal: animalIcon,
    Avian: birdIcon,
    Behaviour: behaviourIcon,
    'Body Area': bodyAreaIcon,
    Canine: canineIcon,
    Cardiorespiratory: pulmonaryAndCardioIcon,
    Chicken: chickenIcon,
    'Chronic conditions': chronicConditionsIcon,
    Dentistry: denistryIcon,
    Dermatology: dermatologyIcon,
    Diagrams: diagramIcon,
    'Emergency & Critical Care': emergencyIcon,
    Equine: equineIcon,
    'Exotic Animals': exoticAnimalsIcon,
    Farm: farmIcon,
    Feline: felineIcon,
    Fish: fishIcon,
    'General principles': generalPrinciplesAnimal,
    'Guinea pig': guineaPigIcon,
    Hamster: hamsterIcon,
    'Internal medicine': internalMedicineIcon,
    'Large Animals': largeAnimalsIcon,
    'Medical conditions': medicalConditionsIcon,
    "Men's health": mensHealthIcon,
    Musculoskeletal: musculoskeletalIcon,
    Neurology: neurologyIcon,
    Ophthalmology: ophthalmologyIcon,
    Orthopaedics: orthopaedicIcon,
    Paediatrics: paediatricsIcon,
    Parasites: parasitesIcon,
    Preventative: preventativeIcon,
    Rabbit: rabbitIcon,
    Reproduction: reproductionIcon,
    Reptiles: reptilesIcon,
    Rheumatology: rheumatologyIcon,
    'Serious pathologies': seriousPathologiesIcon,
    'Small Animals': smallAnimalsIcon,
    'Small mammals': smallMammalsIcon,
    Surgery: surgeryIcon,
    Snake: snakeIcon,
    Tortoise: tortoiseIcon,
    "Women's health": womensHealthIcon,
    'Student Learning': studentLearningIcon,
    'Infectious Disease': infectiousDiseaseIcon,
    Nutrition: nutritionIcon,
    Rehabilitation: rehabilitationIcon,
    Oncology: oncologyIcon,
    Cardiology: cardiologyIcon,
    Gastroenterology: gastroenterologyIcon,
    Hepatology: hepatologyIcon,
    'Nephrology & Urinary': nephrologyUrinaryIcon,
};
const CategoryIcon = observer(({ category }) => {
    const navigate = useNavigate();

    const normalizeCategoryKey = (key) => {
        return key?.replace(/&amp;/g, '&').trim();
    };

    const getCategoryIcon = (category) => {
        const normalizedCategory = normalizeCategoryKey(category);
        const icon = categoryIconMap[normalizedCategory];

        if (!icon) {
            console.warn(`Missing icon for category: "${category}" (normalized: "${normalizedCategory}")`);
        }

        return icon || animalIcon;
    };

    const handleCategoryClick = () => {
        if (category === 'Animal' || category === 'Body Area') {
            navigate('/search/categories');
        } else {
            navigate('/search', { state: { category } });
        }
    };

    return (
        <Box
            onClick={handleCategoryClick}
            sx={{
                width: '40px',
                height: '40px',
                gap: '8px',
                borderRadius: '36px',
                opacity: '0px',
                backgroundColor: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: 1,
                cursor: 'pointer',
            }}
        >
            <img src={getCategoryIcon(category)} alt={`${category} Category Icon`} width="24px" height="24px" />
        </Box>
    );
});

export default CategoryIcon;
